import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { stats } from '@/mocks/comics';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 韩漫漫画网站',
    description: '了解韩漫漫画网站的品牌故事、平台优势与联系方式。海量正版韩国漫画在线阅读平台。',
    url: 'https://www.example.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫漫画网站',
      url: 'https://www.example.com/',
    },
  };

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫漫画网站',
    url: 'https://www.example.com/',
    description: '海量正版韩国漫画在线阅读平台，提供免费的韩国漫画大全，每日更新热门韩漫。',
    foundingDate: '2022',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@example.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫漫画网站的所有漫画都是正版吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩漫漫画网站上的所有漫画均经过正版授权，我们与多家韩国漫画出版方建立了长期合作关系，确保每一部作品的合法合规。',
        },
      },
      {
        '@type': 'Question',
        name: '在韩漫漫画网站阅读漫画需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫漫画网站目前提供免费在线阅读服务，用户无需支付任何费用即可浏览海量正版韩国漫画。未来可能会推出增值服务，但基础阅读功能将始终保持免费。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画的更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们坚持每日更新，确保用户能够第一时间阅读到最新的漫画章节。热门连载漫画通常每周更新1-2话，具体更新速度视版权方的发布计划而定。',
        },
      },
      {
        '@type': 'Question',
        name: '如何搜索我想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过网站顶部的搜索功能，输入漫画名称或作者名来查找您想看的漫画。此外，我们提供了详细的分类导航，您也可以按热血、恋爱、奇幻等类型进行浏览。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }} />

      <Navbar />
      <main className="pt-16">
        <section className="relative bg-gradient-to-br from-primary-800 via-primary-700 to-primary-900 py-16 md:py-24">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 right-10 w-60 h-60 rounded-full bg-accent-500/30 blur-3xl"></div>
            <div className="absolute bottom-10 left-20 w-40 h-40 rounded-full bg-accent-500/20 blur-3xl"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 text-xs text-accent-300 mb-4">
                <Link to="/" className="hover:text-background-50 transition-colors">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-background-50/70">关于我们</span>
              </div>
              <span className="inline-block bg-accent-500/20 border border-accent-400/30 text-accent-200 text-xs font-medium px-3 py-1 rounded-full mb-4">
                品牌介绍
              </span>
              <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-background-50 mb-4">
                关于我们
              </h1>
              <p className="text-sm md:text-base text-background-200/80 max-w-2xl leading-relaxed">
                韩漫漫画网站成立于2022年，致力于为华语读者提供海量正版韩国漫画的在线阅读服务。我们与多家韩国知名漫画出版方合作，确保每一部作品都经过合法授权。
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50" aria-labelledby="story-title">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div>
                  <h2 id="story-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                    我们的<strong>故事</strong>
                  </h2>
                  <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                    <p>
                      韩漫漫画网站的创立源于创始团队对韩国漫画的深厚热爱。在2022年之前，华语地区的韩漫读者面临着资源分散、翻译质量参差不齐、正版内容难以获取等诸多困境。
                    </p>
                    <p>
                      带着「让每一位华语读者都能便捷地阅读到优质正版韩漫」的初心，我们组建了专业的漫画编辑和翻译团队，与韩国多家顶级漫画出版方建立了深度合作关系。从最初仅收录200部作品，到如今已拥有超过12,800部正版漫画的庞大书库。
                    </p>
                    <p>
                      我们深知，<strong>正版授权</strong>不仅是对创作者的尊重，更是保障读者获得高品质阅读体验的基础。每一部在平台上线的作品，都经过了严格的版权审核和本地化处理，让读者能够享受到原汁原味的韩漫魅力。
                    </p>
                  </div>
                </div>
                <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20cozy%20modern%20reading%20space%20with%20bookshelves%20and%20comfortable%20seating%2C%20soft%20natural%20lighting%20through%20large%20windows%2C%20artistic%20interior%20design%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20peaceful%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20detail&width=800&height=600&seq=about-story-2026-v2&orientation=landscape"
                    alt="韩漫漫画网站 - 舒适的阅读空间"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100" aria-labelledby="stats-title">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <span className="inline-block border border-accent-300 text-accent-600 text-xs font-medium px-4 py-1.5 rounded-full">
                  平台数据
                </span>
                <h2 id="stats-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
                  值得信赖的<strong>韩漫平台</strong>
                </h2>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {stats.map((stat) => (
                  <div key={stat.label} className="bg-background-50 rounded-xl p-6 md:p-8 text-center">
                    <p className="font-heading text-3xl md:text-4xl font-extrabold text-primary-600 mb-2">{stat.value}</p>
                    <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50" aria-labelledby="values-title">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <span className="inline-block border border-accent-300 text-accent-600 text-xs font-medium px-4 py-1.5 rounded-full">
                  核心价值
                </span>
                <h2 id="values-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
                  我们的<strong>承诺</strong>
                </h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                <div className="group bg-background-100 hover:bg-primary-500 rounded-xl p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 cursor-default">
                  <div className="w-12 h-12 bg-background-200/70 group-hover:bg-background-50/20 rounded-xl flex items-center justify-center mb-4 transition-colors">
                    <i className="ri-shield-check-line text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                  </div>
                  <h3 className="font-sans text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors mb-2">正版授权</h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    所有漫画均经过官方授权，保障创作者权益，为读者提供合法合规的阅读体验。
                  </p>
                </div>

                <div className="group bg-background-100 hover:bg-primary-500 rounded-xl p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 cursor-default">
                  <div className="w-12 h-12 bg-background-200/70 group-hover:bg-background-50/20 rounded-xl flex items-center justify-center mb-4 transition-colors">
                    <i className="ri-translate-2 text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                  </div>
                  <h3 className="font-sans text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors mb-2">专业翻译</h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    拥有经验丰富的韩漫翻译团队，确保翻译准确流畅，忠实还原原作神韵。
                  </p>
                </div>

                <div className="group bg-background-100 hover:bg-primary-500 rounded-xl p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 cursor-default">
                  <div className="w-12 h-12 bg-background-200/70 group-hover:bg-background-50/20 rounded-xl flex items-center justify-center mb-4 transition-colors">
                    <i className="ri-device-line text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                  </div>
                  <h3 className="font-sans text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors mb-2">流畅体验</h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    采用先进的阅读器技术，高清画质、快速加载，为读者提供沉浸式的阅读享受。
                  </p>
                </div>

                <div className="group bg-background-100 hover:bg-primary-500 rounded-xl p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 cursor-default">
                  <div className="w-12 h-12 bg-background-200/70 group-hover:bg-background-50/20 rounded-xl flex items-center justify-center mb-4 transition-colors">
                    <i className="ri-timer-flash-line text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                  </div>
                  <h3 className="font-sans text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors mb-2">极速更新</h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    与韩国版权方保持紧密协作，确保漫画章节第一时间同步更新，不让你错过任何精彩。
                  </p>
                </div>

                <div className="group bg-background-100 hover:bg-primary-500 rounded-xl p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 cursor-default">
                  <div className="w-12 h-12 bg-background-200/70 group-hover:bg-background-50/20 rounded-xl flex items-center justify-center mb-4 transition-colors">
                    <i className="ri-heart-line text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                  </div>
                  <h3 className="font-sans text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors mb-2">社区互动</h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    建立活跃的读者社区，让大家可以交流阅读心得、分享推荐，一起感受韩漫的魅力。
                  </p>
                </div>

                <div className="group bg-background-100 hover:bg-primary-500 rounded-xl p-6 md:p-8 transition-all duration-300 hover:-translate-y-1 cursor-default">
                  <div className="w-12 h-12 bg-background-200/70 group-hover:bg-background-50/20 rounded-xl flex items-center justify-center mb-4 transition-colors">
                    <i className="ri-global-line text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                  </div>
                  <h3 className="font-sans text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors mb-2">多语种覆盖</h3>
                  <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                    覆盖15+语种的翻译版本，致力于将优质韩漫推向全球，让更多读者享受韩漫文化。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100" aria-labelledby="faq-title">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <span className="inline-block border border-accent-300 text-accent-600 text-xs font-medium px-4 py-1.5 rounded-full">
                  常见问题
                </span>
                <h2 id="faq-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
                  你可能<strong>想知道</strong>
                </h2>
              </div>

              <div className="space-y-3">
                {[
                  { q: '韩漫漫画网站的所有漫画都是正版吗？', a: '是的，韩漫漫画网站上的所有漫画均经过正版授权，我们与多家韩国漫画出版方建立了长期合作关系，确保每一部作品的合法合规。' },
                  { q: '在韩漫漫画网站阅读漫画需要付费吗？', a: '韩漫漫画网站目前提供免费在线阅读服务，用户无需支付任何费用即可浏览海量正版韩国漫画。未来可能会推出增值服务，但基础阅读功能将始终保持免费。' },
                  { q: '漫画的更新频率是怎样的？', a: '我们坚持每日更新，确保用户能够第一时间阅读到最新的漫画章节。热门连载漫画通常每周更新1-2话，具体更新速度视版权方的发布计划而定。' },
                  { q: '如何搜索我想看的漫画？', a: '您可以通过网站顶部的搜索功能，输入漫画名称或作者名来查找您想看的漫画。此外，我们提供了详细的分类导航，您也可以按热血、恋爱、奇幻等类型进行浏览。' },
                ].map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <h3 className="font-sans text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                      <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50" aria-labelledby="contact-title">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <span className="inline-block border border-accent-300 text-accent-600 text-xs font-medium px-4 py-1.5 rounded-full">
                  联系我们
                </span>
                <h2 id="contact-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
                  期待<strong>与你合作</strong>
                </h2>
                <p className="text-sm text-foreground-500 mt-2">
                  无论你是漫画作者、版权方代表，还是对韩漫有热情的读者，都欢迎与我们取得联系。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-background-100 rounded-xl p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-xl flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="font-sans text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-500">contact@example.com</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-xl flex items-center justify-center">
                    <i className="ri-phone-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="font-sans text-sm font-semibold text-foreground-900 mb-1">联系电话</h3>
                  <p className="text-xs text-foreground-500">+86 400-xxx-xxxx</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-xl flex items-center justify-center">
                    <i className="ri-map-pin-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="font-sans text-sm font-semibold text-foreground-900 mb-1">办公地址</h3>
                  <p className="text-xs text-foreground-500">北京市朝阳区xxx街道xxx号</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}